var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7189 7.28916C17.3365 6.90361 16.7629 6.90361 16.3805 7.28916L10.979 12.6867L5.62524 7.28916C5.24283 6.90361 4.66921 6.90361 4.28681 7.28916C3.9044 7.6747 3.9044 8.25301 4.28681 8.63855L10.3097 14.7108C10.5009 14.9036 10.7399 15 10.979 15C11.218 15 11.457 14.9036 11.6482 14.7108L17.6711 8.63855C18.1013 8.3012 18.1013 7.6747 17.7189 7.28916Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.9bf27f05e01a21dd1385c96408b37a3b.svg";
export { ForwardRef as ReactComponent };